import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ParameterResult } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface HomeUsesParams extends DefaultHttpHeaders {}

@Injectable()
export class HomeUsesService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining home uses
   * Service for obtaining home uses
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Catalog/getComeroundHomeUses
   */
  homeUses(params: HomeUsesParams): Observable<ParameterResult[]> {
    return this.get<ParameterResult[]>({
      suffix: '/comeround/catalog/homeUses',
    });
  }
}
